module.exports = __webpack_public_path__ + "static/media/tom.b3a22a1d.jpg";